export default "__VITE_ASSET__0e65a399__"